import { useCallback, useEffect, useState } from 'react';
import type { AllFerienDTO } from '../model/FerienDTO';
import type { AxiosError } from 'axios';
import fetchAuthenticatedFromBackend from '../api/fetchAuthenticatedFromBackend';
import { useAuth } from '../context/AuthContext';

export default function useInternFerien() {
  const [ferien, setFerien] = useState<AllFerienDTO | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<null | AxiosError>(null);
  const { logout } = useAuth();

  const load = useCallback(() => {
    setLoading(true);
    fetchAuthenticatedFromBackend<AllFerienDTO>('intern/ferien')
      .then(setFerien)
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          logout();
        } else {
          setError(err);
        }
      })
      .finally(() => setLoading(false));
  }, [logout]);

  useEffect(() => load(), [load]);

  return { ferien, loading, error, reloadFerien: load };
}
